import services from "@/services/service"

class Fidelio {
  async _init() {
    _$.vue.$on("fidelio", e => this.run(e))
    return true
  }
  async run(e) {
    if (typeof e.body === "string") e.body = JSON.parse(e.body)

    switch (e.fidelio) {
      case "WR":
        this.wakeupRequest(e.body)
        break
      case "WC":
        this.wakeupClear()
        break
      default:
        break
    }
  }
  wakeupRequest(payload) {
    const ts = this_.$moment(payload.DA + payload.TI, "YYMMDDHHmmss").valueOf()
    const date = new Date(ts)
    services.worker.setAlarmClock(false, date)
  }
  wakeupClear() {
    services.worker.clearAlarmClock()
  }
}
export default new Fidelio()
